<template>
  <div class="g-page">
    <div class="content-container">
      <div class="sf-breadcrumb"><b-icon aria-hidden="true" icon="safe2" /> <span>Moliya</span><b-icon aria-hidden="true" icon="chevron-right" /><strong>Seyf</strong></div>
      <div class="header-row">
        <div class="page-heading">
          <div class="heading-icon"><b-icon aria-hidden="true" icon="safe2" /></div>
          <div><h2 class="page-title">Seyf</h2><p>Kassadagi mavjud pullarni seyfga qabul qilish va seyfdan kassaga qaytarish operatsiyalari.</p></div>
        </div>
        <div class="header-actions">
          <button class="btn-out" @click="openTransfer(false)"><b-icon aria-hidden="true" icon="box-arrow-up" /> Kassaga qaytarish</button>
          <button class="add-btn" @click="openTransfer(true)"><b-icon aria-hidden="true" icon="box-arrow-in-down" /> Kassadan qabul qilish</button>
          <Top />
        </div>
      </div>

      <div class="ops-summary">
        <div class="balance-card operations-card">
          <div class="balance-icon"><b-icon aria-hidden="true" icon="arrow-left-right" /></div>
          <div class="balance-copy"><div class="bc-title">Jami operatsiyalar</div><div class="bc-value">{{ items.length }} ta</div><div class="bc-sub">Tanlangan davr bo'yicha</div></div>
        </div>
      </div>

      <div v-for="b in displayBalances" :key="b.pay_type_id" class="balance-grid">
        <div class="balance-card safe-card">
          <div class="balance-icon"><b-icon aria-hidden="true" icon="safe2" /></div>
          <div class="balance-copy"><div class="bc-title">Seyfda mavjud<span v-if="displayBalances.length > 1"> · {{ b.name }}</span></div>
            <div class="bc-value">{{ money(b.safe_balance, b.pay_type_id) }}</div>
            <div class="bc-sub">{{ Number(b.safe_balance) ? 'Hozirgi paytda seyfda' : "Hozircha seyfda pul yo'q" }}</div>
          </div>
        </div>
        <div class="balance-card cash-card">
          <div class="balance-icon"><b-icon aria-hidden="true" icon="cash-stack" /></div>
          <div class="balance-copy"><div class="bc-title">Kassada mavjud<span v-if="displayBalances.length > 1"> · {{ b.name }}</span></div>
            <div class="bc-value">{{ money(b.kassa_balance, b.pay_type_id) }}</div><div class="bc-sub">Hozirgi paytda kassada</div>
          </div>
        </div>
      </div>

      <form class="filter-row" @submit.prevent="loadReport">
        <div class="filter-item"><label for="sf-date-from">Sana (dan)</label><div class="input-wrap"><b-icon aria-hidden="true" icon="calendar4-week" /><input id="sf-date-from" type="date" v-model="date1" required></div></div>
        <div class="filter-item"><label for="sf-date-to">Sana (gacha)</label><div class="input-wrap"><b-icon aria-hidden="true" icon="calendar4-week" /><input id="sf-date-to" type="date" v-model="date2" :min="date1" required></div></div>
        <div class="filter-item"><label for="sf-pay-type">To'lov turi</label><select id="sf-pay-type" v-model="payTypeId"><option :value="0">Barchasi</option><option v-for="p in balances" :key="p.pay_type_id" :value="p.pay_type_id">{{ p.name }}</option></select></div>
        <div class="filter-item search-item"><label class="sr-only" for="sf-search">Izoh bo'yicha qidirish</label><div class="input-wrap"><b-icon aria-hidden="true" icon="search" /><input id="sf-search" v-model="search" type="search" placeholder="Izoh bo'yicha qidirish..."></div></div>
        <button class="add-btn show-btn" type="submit" :disabled="loading"><b-icon aria-hidden="true" icon="search" /> Ko'rsatish</button>
        <button class="refresh-btn" type="button" @click="resetFilters" title="Filtrlarni tozalash va yangilash" aria-label="Filtrlarni tozalash va yangilash" :disabled="loading"><b-icon aria-hidden="true" icon="arrow-repeat" /></button>
      </form>

      <div v-if="items.length" class="summary">
        <div class="sum-item"><span>Davr boshiga</span><b>{{ formatSumma(summary.opening) }}</b></div>
        <div class="sum-item in"><span>Kirim</span><b>+{{ formatSumma(summary.kirim) }}</b></div>
        <div class="sum-item out"><span>Chiqim</span><b>-{{ formatSumma(summary.chiqim) }}</b></div>
        <div class="sum-item"><span>Davr oxiriga</span><b>{{ formatSumma(summary.closing) }}</b></div>
      </div>
      <div v-if="!payTypeId && multiPayType" class="hint">Jami summalarni to'lov turi bo'yicha ko'rish uchun to'lov turini tanlang.</div>

      <section class="table-section">
        <div class="table-heading"><h3><span class="list-icon"><b-icon aria-hidden="true" icon="list-ul" /></span>Seyf harakatlari</h3>
          <button class="excel-btn" @click="exportExcel" :disabled="exporting || !filteredItems.length"><b-icon aria-hidden="true" icon="file-earmark-spreadsheet" /> {{ exporting ? 'Yuklanmoqda...' : 'Excel' }}</button>
        </div>
        <div class="table-wrapper">
          <table class="custom-table" :aria-busy="loading">
            <thead><tr><th>#</th><th>Vaqt</th><th>Harakat</th><th class="text-right">Summa</th><th>Asos / Izoh</th><th>Foydalanuvchi</th><th><span class="sr-only">Amallar</span></th></tr></thead>
            <tbody>
              <tr v-for="(item, index) in filteredItems" :key="item.id">
                <td class="row-number">{{ index + 1 }}</td><td class="date-cell">{{ $formatDate(item.datetime) }}</td>
                <td><span class="tag" :class="tagClass(item)">{{ actionName(item) }}</span></td>
                <td class="text-right"><div :class="item.type ? 'amount-in' : 'amount-out'">{{ item.type ? '+' : '-' }}{{ formatSumma(item.summa) }}</div><small>{{ item.pay_type_name }} · Qoldiq: {{ formatSumma(item.balance) }}</small></td>
                <td><div class="font-bold">{{ item.reason || '-' }}</div><div class="text-muted small" v-if="item.comment">{{ item.comment }}</div></td>
                <td>{{ item.user_name || '-' }}</td>
                <td class="text-center"><button v-if="item.is_transfer" class="icon-btn del" title="O'chirish" aria-label="O'chirish" @click="deleteTransfer(item)"><b-icon aria-hidden="true" icon="trash" /></button>
                  <button v-else class="icon-btn edit" title="Kassa orderni ochish" aria-label="Kassa orderni ochish" @click="$router.push('/kassaorder/update/' + item.doc_id)"><b-icon aria-hidden="true" icon="box-arrow-up-right" /></button></td>
              </tr>
              <tr v-if="loading"><td colspan="7" class="empty-row"><b-icon aria-hidden="true" icon="arrow-repeat" animation="spin" /><p>Yuklanmoqda...</p></td></tr>
              <tr v-else-if="!filteredItems.length"><td colspan="7" class="empty-row">
                <div class="empty-icon"><b-icon aria-hidden="true" icon="box-seam" /></div>
                <h4>{{ search ? "Qidiruv bo'yicha ma'lumot topilmadi" : "Bu davrda seyfda harakat bo'lmagan" }}</h4>
                <p>Kassadan seyfga qabul qilingan yoki seyfdan kassaga qaytarilgan<br class="desktop-break"> pul operatsiyalari shu yerda ko'rinadi.</p>
                <button class="btn-out empty-action" @click="focusFilters"><b-icon aria-hidden="true" icon="search" /> Boshqa davrni ko'rish</button>
              </td></tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-if="modal.show" class="sf-overlay" @click.self="closeModal" @keydown.esc="closeModal" @keydown.tab="trapFocus">
      <section class="sf-modal" role="dialog" aria-modal="true" aria-labelledby="sf-modal-title">
        <div class="sf-head">
          <div class="modal-heading"><div class="heading-icon"><b-icon aria-hidden="true" icon="safe2" /></div><div>
            <h3 id="sf-modal-title">{{ modal.toSafe ? 'Kassadan seyfga qabul qilish' : 'Seyfdan kassaga qaytarish' }}</h3>
            <p>{{ modal.toSafe ? "Kassa pulini seyfga o'tkazish operatsiyasi." : "Seyf pulini kassaga o'tkazish operatsiyasi." }}</p>
          </div></div>
          <button ref="modalClose" class="sf-close" @click="closeModal" :disabled="modal.saving" title="Yopish" aria-label="Yopish"><b-icon aria-hidden="true" icon="x-lg" /></button>
        </div>
        <form @submit.prevent="saveTransfer">
          <div class="sf-body">
            <div class="dir-toggle" role="group" aria-label="O'tkazish yo'nalishi">
              <button type="button" :class="{ active: modal.toSafe }" :aria-pressed="modal.toSafe" :disabled="modal.saving" @click="modal.toSafe = true"><b-icon aria-hidden="true" icon="cash-stack" /> Kassa <b-icon aria-hidden="true" icon="arrow-right" /> Seyf</button>
              <button type="button" :class="{ active: !modal.toSafe }" :aria-pressed="!modal.toSafe" :disabled="modal.saving" @click="modal.toSafe = false"><b-icon aria-hidden="true" icon="safe2" /> Seyf <b-icon aria-hidden="true" icon="arrow-right" /> Kassa</button>
            </div>
            <div class="sf-balances">
              <div class="modal-balance cash-card"><div class="balance-icon"><b-icon aria-hidden="true" icon="cash-stack" /></div><div><span>Kassada mavjud:</span><strong>{{ money(modalBalance.kassa_balance, modal.pay_type_id) }}</strong></div></div>
              <div class="modal-balance safe-card"><div class="balance-icon"><b-icon aria-hidden="true" icon="safe2" /></div><div><span>Seyfda mavjud:</span><strong>{{ money(modalBalance.safe_balance, modal.pay_type_id) }}</strong><small v-if="!Number(modalBalance.safe_balance)">Hozircha seyfda pul yo'q</small></div></div>
            </div>
            <div class="modal-meta">
              <div><label class="sf-label" for="sf-transfer-date">Sana</label><div class="input-wrap"><b-icon aria-hidden="true" icon="calendar4-week" /><input id="sf-transfer-date" type="text" :value="transferDate" readonly></div></div>
              <div v-if="balances.length > 1"><label class="sf-label" for="sf-transfer-pay">To'lov turi</label><select id="sf-transfer-pay" v-model="modal.pay_type_id" class="sf-input" :disabled="modal.saving"><option v-for="p in balances" :key="p.pay_type_id" :value="p.pay_type_id">{{ p.name }}</option></select></div>
            </div>
            <label class="sf-label" for="sf-transfer-sum">O'tkaziladigan summa</label>
            <div class="input-wrap amount-input"><b-icon aria-hidden="true" icon="coin" /><vue-numeric id="sf-transfer-sum" separator="space" v-model="modal.summa" :precision="2" :disabled="modal.saving" placeholder="Summani kiriting" class="sf-sum" /><button type="button" @click="modal.summa = Math.max(0, available)" :disabled="modal.saving || available <= 0">Hammasi</button></div>
            <div class="sf-avail">Maksimal: <b>{{ money(Math.max(0, available), modal.pay_type_id) }}</b></div>
            <label class="sf-label" for="sf-transfer-comment">Izoh (ixtiyoriy)</label>
            <div class="input-wrap comment-input"><b-icon aria-hidden="true" icon="file-earmark-text" /><textarea id="sf-transfer-comment" v-model="modal.comment" :disabled="modal.saving" placeholder="Masalan: kun yakuni, qisman o'tkazish..." rows="2"></textarea></div>
          </div>
          <div class="sf-actions"><button type="button" class="sf-cancel" @click="closeModal" :disabled="modal.saving">Bekor</button><button type="submit" class="sf-save" :disabled="modal.saving"><b-icon aria-hidden="true" :icon="modal.saving ? 'arrow-repeat' : 'check2'" />{{ modal.saving ? 'Saqlanmoqda...' : 'Saqlash' }}</button></div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Top from '../Layout/Top.vue';
import { saveAs } from 'file-saver';

const toInput = d => {
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

export default {
  name: 'SafeIndex',
  components: { Top },
  data() {
    const now = new Date();
    return {
      loading: false,
      search: '',
      exporting: false,
      transferDate: '',
      balances: [],
      items: [],
      report: { opening: {}, closing: {}, totals: {} },
      date1: toInput(new Date(now.getFullYear(), now.getMonth(), 1)),
      date2: toInput(now),
      payTypeId: 0,
      updatePassword: '',
      modal: { show: false, toSafe: true, pay_type_id: 1, summa: 0, comment: '', saving: false },
    };
  },
  computed: {
    skladId() {
      return parseInt(localStorage.getItem('sklad_id')) || 1;
    },
    // Hech qachon ishlatilmagan to'lov turlarini yashiramiz (Naqd doim ko'rinadi)
    visibleBalances() {
      return this.balances.filter(b => b.pay_type_id === 1 || b.safe_balance || b.kassa_balance);
    },
    displayBalances() {
      const rows = this.payTypeId
        ? this.balances.filter(b => b.pay_type_id === this.payTypeId)
        : this.visibleBalances;
      return rows.length ? rows : [{ pay_type_id: 1, name: 'Naqd', safe_balance: 0, kassa_balance: 0 }];
    },
    filteredItems() {
      const query = this.search.trim().toLocaleLowerCase();
      return query ? this.items.filter(item => [item.reason, item.comment].some(value =>
        String(value || '').toLocaleLowerCase().includes(query))) : this.items;
    },
    modalBalance() {
      return this.balances.find(b => b.pay_type_id === this.modal.pay_type_id)
        || { safe_balance: 0, kassa_balance: 0 };
    },
    multiPayType() {
      return Object.keys(this.report.totals || {}).length > 1;
    },
    summary() {
      const pick = obj => {
        if (this.payTypeId) return Number((obj || {})[this.payTypeId] || 0);
        return Object.values(obj || {}).reduce((a, v) => a + Number(v || 0), 0);
      };
      const totals = this.report.totals || {};
      const t = this.payTypeId
        ? (totals[this.payTypeId] || { kirim: 0, chiqim: 0 })
        : Object.values(totals).reduce((a, v) => ({ kirim: a.kirim + v.kirim, chiqim: a.chiqim + v.chiqim }), { kirim: 0, chiqim: 0 });
      return { opening: pick(this.report.opening), closing: pick(this.report.closing), kirim: t.kirim, chiqim: t.chiqim };
    },
    available() {
      const b = this.balances.find(x => x.pay_type_id === this.modal.pay_type_id);
      if (!b) return 0;
      return this.modal.toSafe ? b.kassa_balance : b.safe_balance;
    },
  },
  mounted() {
    this.loadAll();
    axios.get('api/v1/sklads/id/' + this.skladId)
      .then(r => { this.updatePassword = r.data.update_password; })
      .catch(() => {});
  },
  methods: {
    money(value, payTypeId) {
      const payType = this.balances.find(b => b.pay_type_id === payTypeId);
      return this.formatSumma(value) + ' ' + (payTypeId === 1 ? "so'm" : (payType ? payType.name : ''));
    },
    resetFilters() {
      const now = new Date();
      this.date1 = toInput(new Date(now.getFullYear(), now.getMonth(), 1));
      this.date2 = toInput(now);
      this.payTypeId = 0;
      this.search = '';
      this.loadAll();
    },
    focusFilters() {
      this.search = '';
      document.getElementById('sf-date-from').focus();
    },
    closeModal() {
      if (this.modal.saving) return;
      this.modal.show = false;
      if (this.transferTrigger) this.transferTrigger.focus();
    },
    trapFocus(event) {
      const elements = Array.from(event.currentTarget.querySelectorAll('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled)'));
      const first = elements[0], last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    },
    async exportExcel() {
      if (this.exporting || !this.filteredItems.length) return;
      this.exporting = true;
      try {
        const XLSX = await import('xlsx');
        const rows = this.filteredItems.map((item, index) => ({
          '#': index + 1, 'Vaqt': this.$formatDate(item.datetime),
          'Harakat': this.actionName(item), "To'lov turi": item.pay_type_name,
          'Kirim': item.type ? Number(item.summa) : 0,
          'Chiqim': item.type ? 0 : Number(item.summa),
          'Qoldiq': Number(item.balance), 'Asos': item.reason || '',
          'Izoh': item.comment || '', 'Foydalanuvchi': item.user_name || ''
        }));
        const sheet = XLSX.utils.json_to_sheet(rows);
        sheet['!cols'] = [6, 22, 24, 18, 18, 18, 18, 30, 40, 22].map(wch => ({ wch }));
        const book = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(book, sheet, 'Seyf harakatlari');
        const data = XLSX.write(book, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), 'Seyf_' + this.date1 + '_' + this.date2 + '.xlsx');
      } catch (e) {
        this.$store.state.errors = 'Excel faylini yuklashda xatolik yuz berdi';
      } finally { this.exporting = false; }
    },
    formatSumma(s) {
      return Number(s || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 }).replace(/,/g, '.');
    },
    actionName(item) {
      if (item.is_transfer) return item.type ? 'Kassadan kirdi' : 'Kassaga qaytdi';
      return item.type ? 'Kirim' : 'Xarajat';
    },
    tagClass(item) {
      if (item.is_transfer) return item.type ? 'tag-transfer-in' : 'tag-transfer-out';
      return item.type ? 'tag-in' : 'tag-out';
    },
    loadAll() {
      this.loadBalance();
      this.loadReport();
    },
    async loadBalance() {
      try {
        const res = await axios.get('api/v1/safe/balance', { params: { sklad_id: this.skladId } });
        this.balances = res.data || [];
      } catch (e) { this.balances = []; }
    },
    async loadReport() {
      if (!this.date1 || !this.date2 || this.date1 > this.date2) {
        this.$store.state.errors = "Sana oralig'ini to'g'ri tanlang";
        return;
      }
      this.loading = true;
      try {
        const d1 = Math.floor(new Date(this.date1 + 'T00:00:00').getTime() / 1000);
        const d2 = Math.floor(new Date(this.date2 + 'T23:59:59').getTime() / 1000);
        const res = await axios.get('api/v1/safe/report', {
          params: { sklad_id: this.skladId, date1: d1, date2: d2, pay_type_id: this.payTypeId || undefined }
        });
        this.report = res.data;
        this.items = res.data.items || [];
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    openTransfer(toSafe) {
      this.transferTrigger = document.activeElement;
      const now = new Date();
      this.transferDate = String(now.getDate()).padStart(2, '0') + '/' + String(now.getMonth() + 1).padStart(2, '0') + '/' + now.getFullYear();
      this.modal = { show: true, toSafe, pay_type_id: this.payTypeId || 1, summa: 0, comment: '', saving: false };
      this.$nextTick(() => this.$refs.modalClose.focus());
      this.loadBalance();
    },
    async saveTransfer() {
      if (this.modal.saving) return;
      if (!(Number(this.modal.summa) > 0)) {
        this.$store.state.errors = 'Summani kiriting';
        return;
      }
      if (Number(this.modal.summa) > Number(this.available)) {
        this.$store.state.errors = (this.modal.toSafe ? 'Kassada' : 'Seyfda') + " yetarli mablag' yo'q";
        return;
      }
      this.modal.saving = true;
      try {
        await axios.post('api/v1/safe/transfer', {
          sklad_id: this.skladId,
          pay_type_id: this.modal.pay_type_id,
          summa: this.modal.summa,
          direction: this.modal.toSafe ? 1 : 0,
          comment: this.modal.comment,
        });
        this.modal.show = false;
        if (this.transferTrigger) this.transferTrigger.focus();
        this.loadAll();
      } catch (e) {
        this.$store.state.errors = (e.response && e.response.data && e.response.data.message) || 'Xatolik yuz berdi';
      } finally {
        this.modal.saving = false;
      }
    },
    deleteTransfer(item) {
      this.$prompt(this.$t('Паролни киритинг'))
        .then(async text => {
          if (text != this.updatePassword) {
            this.$store.state.errors = this.$t('Парол хато');
            return;
          }
          try {
            await axios.delete('api/v1/safe/transfer/id/' + item.doc_id);
            this.loadAll();
          } catch (e) {
            this.$store.state.errors = (e.response && e.response.data && e.response.data.message) || 'Xatolik yuz berdi';
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.g-page { --purple: #902bfa; --ink: #101a31; --muted: #62728f; padding: 0 24px 24px; background: #f6f8fb; height: calc(100vh - 56px); height: calc(100dvh - 56px); min-height: 0; overflow-y: auto; overscroll-behavior-y: contain; color: var(--ink); letter-spacing: 0; }
.content-container { max-width: 1600px; margin: 0 auto; }
.sf-breadcrumb { height: 54px; display: flex; align-items: center; gap: 16px; border-bottom: 1px solid #e7edf4; color: var(--muted); margin-bottom: 18px; font-size: 14px; }
.sf-breadcrumb strong { color: var(--ink); }
.header-row, .header-actions, .page-heading, .modal-heading { display: flex; align-items: center; gap: 18px; }
.header-row { justify-content: space-between; margin-bottom: 20px; flex-wrap: wrap; }
.page-heading { flex: 1; min-width: 260px; }
.heading-icon { width: 78px; height: 78px; border-radius: 14px; background: #f3eaff; color: var(--purple); border: 1px solid #dec7ff; display: flex; align-items: center; justify-content: center; font-size: 42px; flex-shrink: 0; }
.page-title { color: var(--ink); font-size: 28px; font-weight: 800; margin: 0 0 5px; }
.page-heading p, .sf-head p { color: #536482; font-size: 14px; line-height: 1.5; margin: 0; }
.header-actions { gap: 8px; flex-wrap: wrap; }
button { cursor: pointer; transition: background .15s, border-color .15s; }
button:disabled { opacity: .55; cursor: not-allowed; }
button:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible { outline: 2px solid var(--purple); outline-offset: 3px; }
.add-btn, .btn-out, .excel-btn, .sf-save, .sf-cancel { min-height: 44px; border-radius: 8px; padding: 10px 16px; font-size: 14px; font-weight: 700; display: inline-flex; justify-content: center; align-items: center; gap: 10px; line-height: 1.35; }
.add-btn, .sf-save { background: linear-gradient(110deg, #a130fa, #791bfa); color: #fff; border: 1px solid #8b26fa; }
.add-btn:hover, .sf-save:hover { background: #7f1ce8; }
.btn-out { background: #fff; color: var(--purple); border: 1px solid #e6d8ff; }
.btn-out:hover { background: #f7f1ff; }
.refresh-btn, .sf-close { width: 46px; height: 44px; display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; border-radius: 8px; border: 1px solid #dde5ef; background: #fff; color: var(--ink); font-size: 20px; }
.ops-summary { margin-bottom: 18px; }
.ops-summary .balance-card { max-width: 340px; }
.balance-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; margin-bottom: 18px; }
.balance-card { display: flex; align-items: center; gap: 24px; border: 1px solid #e5eaf2; border-radius: 8px; padding: 22px 28px; min-height: 126px; background: #fff; }
.safe-card { background: #faf6ff; border-color: #eee4fc; }
.cash-card { background: #f4f9ff; border-color: #e0ecff; }
.balance-icon { width: 72px; height: 72px; border-radius: 16px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 38px; }
.safe-card .balance-icon { color: var(--purple); background: #eee1ff; }
.cash-card .balance-icon { color: #006dff; background: #dfecff; }
.operations-card .balance-icon { color: #d69a32; background: #fff6e9; }
.balance-copy { min-width: 0; }
.bc-title, .bc-sub { font-size: 14px; color: #536482; line-height: 1.5; }
.bc-value { font-weight: 800; font-size: 28px; line-height: 1.35; margin: 3px 0; overflow-wrap: anywhere; }
.safe-card .bc-value { color: var(--purple); }
.cash-card .bc-value { color: #004df5; }
.filter-row { display: flex; gap: 16px; align-items: flex-end; flex-wrap: wrap; background: #fff; border-block: 1px solid #e5eaf2; padding: 20px 24px; margin-bottom: 18px; }
.filter-item { flex: 1 1 175px; min-width: 0; }
.filter-item label { display: block; font-size: 13px; color: var(--muted); margin-bottom: 5px; }
.input-wrap { display: flex; align-items: center; gap: 14px; padding: 0 16px; border: 1px solid #d5dfed; border-radius: 8px; background: #fff; min-height: 46px; min-width: 0; }
.input-wrap > .b-icon { color: #5d6d87; font-size: 20px; flex-shrink: 0; }
.input-wrap input, .input-wrap textarea { width: 100%; min-width: 0; border: 0; background: transparent; outline: none; color: var(--ink); font-size: 14px; }
.input-wrap input { height: 44px; }
.input-wrap:focus-within { border-color: var(--purple); box-shadow: 0 0 0 2px #f2e8ff; }
input::placeholder, textarea::placeholder { color: #8a96ac; }
.filter-item select, .sf-input { height: 46px; width: 100%; border: 1px solid #d5dfed; border-radius: 8px; padding: 0 14px; background: #fff; color: var(--ink); font-size: 14px; }
.search-item { flex: 1.2 1 200px; }
.summary { display: flex; gap: 28px; flex-wrap: wrap; padding: 0 8px 16px; }
.sum-item { display: flex; gap: 8px; align-items: baseline; font-size: 13px; color: var(--muted); }
.sum-item b { color: var(--ink); }
.sum-item.in b, .amount-in { color: #079268; }
.sum-item.out b, .amount-out { color: #dd405c; }
.hint { color: #9f6e24; font-size: 12px; margin-bottom: 12px; }
.table-section { background: #fff; border-block: 1px solid #e5eaf2; padding: 16px 18px 18px; }
.table-heading { display: flex; justify-content: space-between; align-items: center; gap: 14px; margin-bottom: 16px; }
.table-heading h3 { display: flex; align-items: center; gap: 14px; font-size: 18px; font-weight: 800; margin: 0; }
.list-icon { width: 44px; height: 44px; border-radius: 8px; background: #f5eeff; color: var(--purple); display: inline-flex; align-items: center; justify-content: center; font-size: 24px; }
.excel-btn { background: #fff; border: 1px solid #dce5ef; color: var(--ink); }
.table-wrapper { overflow-x: auto; border: 1px solid #edf1f6; border-radius: 8px; }
.custom-table { width: 100%; border-collapse: collapse; }
.custom-table th { background: #f8f9fc; color: #72819d; font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 14px 18px; text-align: left; white-space: nowrap; }
.custom-table td { padding: 14px 18px; border-top: 1px solid #edf1f6; font-size: 13px; vertical-align: middle; }
.custom-table td small { color: var(--muted); font-size: 11px; white-space: nowrap; }
.date-cell { white-space: nowrap; color: var(--muted); }
.row-number { color: var(--muted); }
.text-right { text-align: right !important; }
.text-center { text-align: center; }
.font-bold, .amount-in, .amount-out { font-weight: 700; }
.empty-row { text-align: center; padding: 38px 20px 24px !important; height: 290px; }
.empty-icon { display: flex; justify-content: center; align-items: center; color: #b58aff; font-size: 76px; height: 92px; margin-bottom: 10px; }
.empty-row h4 { font-size: 17px; font-weight: 700; color: var(--ink); margin: 10px 0 4px; }
.empty-row p { font-size: 14px; line-height: 1.7; color: #7b8ba6; margin-bottom: 16px; }
.empty-action { border-color: #ad6cff; margin: 0 auto; }
.tag { display: inline-block; padding: 5px 10px; border-radius: 6px; font-size: 12px; font-weight: 700; white-space: nowrap; }
.tag-transfer-in { background: #f3e8ff; color: #7c3aed; }
.tag-transfer-out { background: #fff3d8; color: #a87921; }
.tag-in { background: #dcfce7; color: #15803d; }
.tag-out { background: #ffe4e6; color: #be123c; }
.icon-btn { width: 32px; height: 32px; border-radius: 6px; border: none; display: inline-flex; align-items: center; justify-content: center; }
.icon-btn.del { background: #fff1f2; color: #e11d48; }
.icon-btn.edit { background: #eff6ff; color: #2563eb; }
.sf-overlay { position: fixed; inset: 0; background: #16203399; backdrop-filter: blur(6px); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 24px; overflow-y: auto; }
.sf-modal { background: #fff; border-radius: 22px; width: 100%; max-width: 780px; max-height: calc(100dvh - 48px); overflow-y: auto; box-shadow: 0 24px 70px #0c152c40; color: var(--ink); }
.sf-head { display: flex; justify-content: space-between; align-items: center; gap: 16px; padding: 22px 28px; border-bottom: 1px solid #e7edf4; }
.modal-heading { min-width: 0; gap: 22px; }
.sf-head .heading-icon { width: 66px; height: 66px; border: 0; font-size: 36px; }
.sf-head h3 { margin: 0 0 7px; font-size: 24px; font-weight: 800; line-height: 1.3; }
.sf-head p { font-size: 16px; }
.sf-close { background: #f0f3f7; color: #627089; border: 0; width: 48px; height: 48px; }
.sf-body { padding: 18px 28px; }
.dir-toggle { display: grid; grid-template-columns: 1fr 1fr; background: #f0f3f7; border-radius: 10px; margin-bottom: 18px; }
.dir-toggle button { border: 1px solid transparent; background: transparent; padding: 16px 8px; border-radius: 10px; font-size: 18px; font-weight: 700; color: #5d6a84; display: flex; align-items: center; justify-content: center; gap: 8px; }
.dir-toggle button > .b-icon:first-child { font-size: 28px; margin-right: 6px; }
.dir-toggle button.active { background: #f8f2ff; color: var(--purple); border: 1.5px solid var(--purple); }
.sf-balances { display: grid; grid-template-columns: 1fr 1fr; background: linear-gradient(100deg, #f0f7ff, #f8f2ff); border-radius: 10px; padding: 20px 18px; margin-bottom: 16px; }
.modal-balance { display: flex; align-items: center; gap: 22px; background: transparent; min-width: 0; }
.modal-balance + .modal-balance { border-left: 1px solid #ced9e8; padding-left: 28px; }
.modal-balance .balance-icon { width: 68px; height: 68px; font-size: 36px; }
.modal-balance > div:last-child { min-width: 0; }
.modal-balance span, .modal-balance small { display: block; font-size: 14px; color: #536482; }
.modal-balance strong { display: block; font-size: 26px; font-weight: 800; line-height: 1.4; overflow-wrap: anywhere; }
.modal-balance.cash-card strong { color: #004df5; }
.modal-meta { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; }
.sf-label { display: block; font-size: 15px; font-weight: 700; color: #5e6d87; margin: 14px 0 6px; }
.amount-input { padding-right: 6px; min-height: 50px; }
.amount-input button { flex-shrink: 0; padding: 7px 14px; color: var(--purple); background: #f8f2ff; border: 1px solid #e4d4ff; border-radius: 6px; font-weight: 700; font-size: 15px; }
.sf-avail { font-size: 14px; color: #657490; margin: 6px 0 20px; }
.comment-input { align-items: flex-start; padding-top: 14px; padding-bottom: 10px; }
.comment-input textarea { resize: vertical; min-height: 48px; }
.sf-actions { display: flex; gap: 14px; justify-content: flex-end; padding: 18px 28px; border-top: 1px solid #e7edf4; }
.sf-cancel { background: #f0f3f7; color: #5e6d87; border: none; min-width: 104px; }
.sf-save { min-width: 140px; }
.sf-actions button { font-size: 17px; min-height: 52px; }
.sf-save .b-icon { font-size: 24px; }
@media (max-width: 1200px) {
  .header-actions { margin-left: auto; }
  .balance-card { padding: 18px; gap: 14px; }
  .balance-icon { width: 56px; height: 56px; font-size: 30px; }
  .bc-value { font-size: 24px; }
}
@media (max-width: 760px) {
  .g-page { padding: 0 14px 16px; }
  .page-heading { align-items: flex-start; }
  .page-heading .heading-icon { width: 60px; height: 60px; font-size: 34px; }
  .page-title { font-size: 24px; }
  .header-actions { margin-left: 0; width: 100%; }
  .balance-grid { grid-template-columns: 1fr; gap: 10px; }
  .ops-summary .balance-card { max-width: none; }
  .balance-card { min-height: 104px; }
  .filter-row { padding: 16px 0; gap: 12px; }
  .filter-item { flex-basis: calc(50% - 12px); }
  .search-item { flex-basis: 100%; }
  .table-section { padding: 14px 0; }
  .table-heading h3 { font-size: 16px; gap: 10px; }
  .table-wrapper { border-radius: 0; }
  .empty-row { padding: 28px 16px !important; }
  .desktop-break { display: none; }
  .sf-overlay { padding: 12px; }
  .sf-modal { border-radius: 16px; max-height: calc(100dvh - 24px); }
  .sf-head { padding: 18px; align-items: flex-start; }
  .sf-head .heading-icon { width: 48px; height: 48px; font-size: 28px; }
  .modal-heading { gap: 12px; }
  .sf-head h3 { font-size: 19px; }
  .sf-head p { font-size: 13px; }
  .sf-close { width: 34px; height: 34px; }
  .sf-body { padding: 16px 18px; }
  .dir-toggle button { font-size: 14px; gap: 4px; padding: 14px 4px; }
  .dir-toggle button > .b-icon:first-child { font-size: 20px; margin-right: 2px; }
  .sf-balances { padding: 14px; gap: 16px; grid-template-columns: 1fr; }
  .modal-balance { gap: 14px; }
  .modal-balance + .modal-balance { border-left: 0; border-top: 1px solid #dce2ef; padding: 14px 0 0; }
  .modal-balance .balance-icon { width: 52px; height: 52px; font-size: 28px; }
  .modal-balance strong { font-size: 23px; }
  .modal-meta { grid-template-columns: 1fr; gap: 0; }
  .sf-actions { padding: 16px 18px; }
}
</style>
